import { MapPin } from '@phosphor-icons/react';
import './Vacancies.css';

const jobs = [
  {
    title: 'TIG Lasser',
    location: 'Rotterdam',
    type: 'Fulltime',
    sector: 'Metaal',
    image: '/assets/vacatures/tig-lasser.jpg',
    description: 'Wij zoeken ervaren TIG lassers voor projecten in de scheepsbouw.',
    requirements: ['TIG certificaat', 'Min. 2 jaar ervaring', 'VCA'],
  },
  {
    title: 'Constructiebankwerker',
    location: 'Amsterdam',
    type: 'Fulltime',
    sector: 'Bouw',
    image: '/assets/vacatures/constructiebankwerker.jpg',
    description: 'Bankwerker gezocht voor constructiewerk op diverse projecten.',
    requirements: ['MBO niveau', 'Lezen van tekeningen', 'Zelfstandig werken'],
  },
  {
    title: 'Scheepstimmerman',
    location: 'Schiedam',
    type: 'Fulltime',
    sector: 'Maritiem',
    image: '/assets/vacatures/scheepstimmerman.jpg',
    description: 'Voor maritieme projecten zoeken wij ervaren scheepstimmerlieden.',
    requirements: ['Maritieme ervaring', 'Havenvergunning', 'VCA'],
  },
  {
    title: 'MIG/MAG Lasser',
    location: 'Rotterdam',
    type: 'Fulltime / Parttime',
    sector: 'Industrie',
    image: '/assets/vacatures/mig-mag-lasser.jpg',
    description: 'Industriële lasser gezocht voor langdurig project in havengebied.',
    requirements: ['MIG/MAG certificaat', 'Flexibele werktijden', 'Eigen vervoer'],
  },
];

const benefits = [
  { title: 'Marktconform salaris', desc: 'Goede beloning volgens cao' },
  { title: 'Lange termijn', desc: 'Werk voor langere periode' },
  { title: 'Doorgroei', desc: 'Opleidingsmogelijkheden' },
  { title: 'Veiligheid', desc: 'VCA en veiligheidsbewust' },
];

const Vacancies = () => {
  return (
    <section className="vacancies" id="vacatures">
      <div className="vac-container">
        {/* Header */}
        <div className="vac-header">
          <span className="vac-tag">Vacatures</span>
          <h2 className="vac-title">Kom bij ons werken</h2>
          <p className="vac-subtitle">
            Wij zijn altijd op zoek naar gedreven vakmensen. Bekijk onze openstaande vacatures.
          </p>
        </div>

        {/* Jobs */}
        <div className="jobs-grid">
          {jobs.map((job) => (
            <article key={job.title} className="job-card">
              <div className="job-image-wrapper">
                <img src={job.image} alt={job.title} className="job-image" loading="lazy" />
              </div>
              <div className="job-body">
                <div className="job-header">
                  <span className="job-sector">{job.sector}</span>
                  <span className="job-type">{job.type}</span>
                </div>
                <h3 className="job-title">{job.title}</h3>
                <div className="job-location">
                  <MapPin size={15} weight="regular" aria-hidden="true" />
                  {job.location}
                </div>
                <p className="job-description">{job.description}</p>
                <ul className="job-requirements">
                  {job.requirements.map((req) => (
                    <li key={req} className="job-req-tag">{req}</li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className="job-apply"
                  onClick={() => window.dispatchEvent(new CustomEvent('ozel:apply', {
                    detail: { title: job.title, location: job.location },
                  }))}
                >
                  Solliciteer direct
                </a>
              </div>
            </article>
          ))}
        </div>

        {/* Benefits — hairline spec list, not repeated icon cards */}
        <div className="benefits-section">
          <h3 className="benefits-title">Werken bij Özel</h3>
          <dl className="benefits-list">
            {benefits.map((benefit) => (
              <div key={benefit.title} className="benefit-item">
                <dt>{benefit.title}</dt>
                <dd>{benefit.desc}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default Vacancies;
